import { IconWorld } from '@tabler/icons-react';

import { DonutChart } from '@charts';
import { useResolvedCssColor } from '@charts/helpers';

// `summary.salesTotal` is the paid-charge COUNT — the only currency-safe figure to
// put on one chart (BRL and USD amounts must never share a scale). So the split is
// national vs international by number of sales, not by value.
function salesCount(report, currency) {
    const bucket = report?.currencyReports?.find(r => r.currency === currency);
    return Number(bucket?.summary?.salesTotal) || 0;
}

export default function SalesSplitCard({ report, reportLoading }) {
    const nationalColor = useResolvedCssColor('--chart-1');
    const internationalColor = useResolvedCssColor('--chart-7');

    const slices = [
        { id: 'national', label: 'Nacional (BRL)', value: salesCount(report, 'BRL'), color: nationalColor },
        { id: 'international', label: 'Internacional (USD)', value: salesCount(report, 'USD'), color: internationalColor },
    ];

    return (
        <DonutChart
            title="Distribuição de vendas"
            icon={<IconWorld size={15} />}
            slices={slices}
            valueType="number"
            unitSingular="venda"
            unitPlural="vendas"
            centerLabel="vendas"
            emptyMessage="Sem vendas no período selecionado."
            report={report}
            reportLoading={reportLoading}
        />
    );
}
